import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjSummaryEmbedRoute: InvariantJiraRoute = {
	name: 'software-plan-summary-embed',
	path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed',
};
